import React from 'react';
import { CondoTownhouse, MultiFamily, SingleFamily } from '../assets/icons';

function PropertyIcon(props) {
    const propertyType = props.propertyType;
    const fill = props.fill;
    const size = props.size;
    const className = props.className;
    return (
        propertyType === "CONDO" || propertyType === "TWNH" ? 
        <CondoTownhouse size={size} fill={fill} className={className} /> 
        : 
        propertyType === "MFR" ? 
        <MultiFamily size={size} fill={fill} className={className} /> 
        : 
        <SingleFamily size={size} fill={fill} className={className} />
    )
};

export default PropertyIcon;